import type { FilterResult } from '../../services/filter';
/**
 * Filters the data using Butterworth filtering concept
 *
 * @module
 */
export default class ButterworthFilter {
  /**
   * Filters the data
   * @function
   * @param {float} frequency
   * @param {float} fc
   * @param {int} filterOrder
   * @returns {FilterResult}
   */
  filterOne(frequency: number, fc: number, filterOrder: number): FilterResult {
    const a = 1 + Math.pow(frequency / fc, 2 * filterOrder),
      b = Math.abs(1 / Math.sqrt(a)),
      c = (20 * Math.log(b)) / Math.log(10);

    return { filterAmplitude: c, filterAttenuation: b };
  }
}
